export default __webpack_public_path__ + "static/media/forget.9a78c03c.png";